export const includeSpamWords = [
  'ganapies',
  'arreplegats',
  'minyons',
  'lagart',
  'muixer',
  'vella',
  'jove',
  'puta ',
  'puto ',
  'putu ',
  'putes ',
  'putos ',
  'putus ',
  'azu',
  'gnp',
  'trempat',
  'espany',
];

export const exactSpamWords = [
  'no',
  'nop',
  'noup',
  'nopas',
  'res',
  'cap',
  'gracies',
];

const letterPatternRules = [
  {pattern: /g.{0,2}n.{0,2}p/, description: 'Contains g,n,p close together (max 2 chars between)'},
  {pattern: /r.{0,2}r.{0,2}p.{0,2}g.{0,2}t/, description: 'Contains r,r,p,g,t close together (max 2 chars between)'},
];

export const isResponseSpam = (response) => {
  const trimmed = response.trim();
  if (trimmed === '') return true;

  const sanitized = trimmed
    .toLowerCase()
    .normalize("NFD")
    .replace(/@/g, "a")
    .replace(/[^a-zA-Z]/g, "");

  // Check includeSpamWords and exactSpamWords on the full sanitized text
  if (includeSpamWords.some(word => sanitized.includes(word)) ||
      exactSpamWords.some(word => sanitized === word)) {
    return true;
  }

  // Check letter patterns only within individual words (separated by spaces)
  const words = response
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/@/g, "a")
    .split(/\s+/)
    .map(word => word.replace(/[^a-zA-Z]/g, ""));

  return words.some(word =>
    letterPatternRules.some(rule => rule.pattern.test(word))
  );
};
